import React from "react";
import scrollToComponent from "react-scroll-to-component";

import "./ExpandDetails.css";

const ExpandDetails = props => {
  const { boxData, boxStatusDesc, expanded, expired, onClick } = props;
  const { currentBox } = boxData || {};
  const { boxStatus } = currentBox || {};

  const expandText = expanded => {
    return expanded ? "Hide Details" : "View Box & Shipping Details";
  };

  const expandSymbol = expanded => {
    return expanded ? "×" : "+";
  };

  let expandDetails;

  const onExpandToggle = () => {
    onClick();
    scrollToComponent(expandDetails, {
      offset: 0,
      align: "top",
      duration: 500
    });
  };

  const getDescription = () => {
    if (expired) {
      return boxStatusDesc["EXPIRED"];
    }

    if (boxStatusDesc[boxStatus]) {
      return `Box Status: ${boxStatusDesc[boxStatus]}`;
    }

    return boxStatusDesc["BOX_STATUS_NO_BOX"];
  };

  return (
    <div
      ref={section => {
        expandDetails = section;
      }}
      className="d-flex flex-fdc flex-jsb flex-aic w-100 pos-r"
    >
      <div className="hor-rule mar-h-8" />
      <button
        onClick={onExpandToggle}
        className="ff-ns fs-16 lh-lg c-brand naked-button cur-pointer"
      >
        {expandText(expanded)}
      </button>
      {boxStatus && <div className="fw-bold fs-14 box-status-desc">{getDescription()}</div>}

      <button
        onClick={onExpandToggle}
        className="float-r pos-a fs-24 expand-icon naked-button cur-pointer"
      >
        {expandSymbol(expanded)}
      </button>
    </div>
  );
};

export default ExpandDetails;



// WEBPACK FOOTER //
// ./src/Components/Header/ExpandDetails/ExpandDetails.js